import { useEffect } from 'react';

const isProd = process.env.NODE_ENV === 'production';
const GA_MEASUREMENT_ID = 'G-XXXXXXXXXX';
const META_PIXEL_ID = 'XXXXXXXXXX';

export const initGA = () => {
  if (typeof window === 'undefined' || GA_MEASUREMENT_ID === 'G-XXXXXXXXXX') return;
  const script = document.createElement('script');
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  script.async = true;
  document.head.appendChild(script);
  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  window.gtag = gtag;
  gtag('js', new Date());
  gtag('config', GA_MEASUREMENT_ID, { page_path: window.location.pathname });
};

export const initMetaPixel = () => {
  if (typeof window === 'undefined' || META_PIXEL_ID === 'XXXXXXXXXX') return;
  !function(f,b,e,v,n,t,s) {
    if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)
  }(window, document,'script','https://connect.facebook.net/en_US/fbevents.js');
  window.fbq('init', META_PIXEL_ID);
  window.fbq('track', 'PageView');
};

export const trackPageView = (url) => {
  if (window.gtag) window.gtag('config', GA_MEASUREMENT_ID, { page_path: url });
  if (window.fbq) window.fbq('track', 'PageView');
};

export const trackEvent = (eventName, params = {}) => {
  if (window.gtag) window.gtag('event', eventName, params);
  if (window.fbq) window.fbq('trackCustom', eventName, params);
};

export const Analytics = {
  viewProduct: (product) => {
    trackEvent('view_item', {
      currency: 'INR', value: 0,
      items: [{ item_id: product.id, item_name: product.name, item_category: product.category }]
    });
    if (window.fbq) window.fbq('track', 'ViewContent', {
      content_name: product.name, content_category: product.category,
      content_ids: [product.id], content_type: 'product'
    });
  },
  submitLeadForm: (formType, data = {}) => {
    trackEvent('generate_lead', { form_type: formType, ...data });
    if (window.fbq) window.fbq('track', 'Lead', { content_name: formType });
  },
  submitContactForm: (data = {}) => {
    trackEvent('contact_form_submit', data);
    if (window.fbq) window.fbq('track', 'Contact');
  },
  ctaClick: (ctaName, location) => trackEvent('cta_click', { cta_name: ctaName, location }),
  navClick: (pageName) => trackEvent('navigation_click', { page: pageName }),
  search: (query) => {
    trackEvent('search', { search_term: query });
    if (window.fbq) window.fbq('track', 'Search', { search_string: query });
  }
};

export const AnalyticsProvider = ({ children }) => {
  useEffect(() => { initGA(); initMetaPixel(); }, []);
  return children;
};

export default Analytics;
